<app-header [forceLightBackground]="true"></app-header>
<div class="provider-my-request">
  <div class="provider-my-request--layout">
    <app-provider-sidebar class="provider-my-request--sidebar"></app-provider-sidebar>
    <div class="provider-my-request--content">
      <app-page-header></app-page-header>
      <app-my-request-shared></app-my-request-shared>
    </div>
  </div>
</div>
